import type { FaireProductEntity } from "../../entity_types/product";

export const p_764jd2hz8l: FaireProductEntity = {
  token: "p_764jd2hz8l",
  type: "product",
  name: "Cabin Fever Rustic Vintage Farmhouse Wood Wick Candle",
  brandName: "Anchored Northwest",
  imageUrl:
    "https://cdn.faire.com/fastly/38d386b0b007206f0180a5e31634a9fb51c26e4e9fced9d1afb8c2a5bcc315fa.png",
  priceDollars: 13.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/80e53af5ecb8ac07c3f17e6047f5e1ffbdec8da6d97ac48639cade825946bfd1.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
